import React from 'react';
import { matchPath, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../Stores/useAuthStore';
import * as paths from '../paths';

export default function ProtectedRouteRole({
  children,
}: {
  children?: React.ReactNode;
}): JSX.Element {
  const { user } = useAuthStore();
  const currentLocation = useLocation();

  if (user?.isAdmin || user?.isRecruiter) return children ? <>{children}</> : <Outlet />;

  if (user?.isOperations) {
    if (
      currentLocation.pathname === paths.CANDIDATES ||
      currentLocation.pathname === paths.REPORTS ||
      matchPath(`${paths.CANDIDATE_DETAIL}/*`, currentLocation.pathname)
    ) {
      return <Navigate to="/planner" replace />;
    }
  }

  if (user?.isInternal) return <Navigate to="/planner" replace />;

  return children ? <>{children}</> : <Outlet />;
}
